import React from "react";
import styled from "styled-components";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { AddSupportMessage } from "api/services/support";
import Button from "components/UI/Buttons/Button";
import { UseOrganizationContext } from "contexts";
import * as Yup from 'yup'
import { useHistory } from "react-router-dom";
import Loader from "components/UI/Loader";
import { UseErrorContext } from "contexts";

const FormWrapper = styled.div`
`;

const ValidationSchema = Yup.object().shape({
  message: Yup.string().required('Verplicht'),
}) 

export const SupportForm = () => {
  const history = useHistory();
  const { updateError } = UseErrorContext();

  const callBack = async (values) => {
    try{
      const resp = await AddSupportMessage(values);
      return resp;
    } catch (err) {
      updateError(err);
    }
  };

  return (
      <FormWrapper>
          <Formik
            initialValues={{ 
              message: ""               
              }}
            validationSchema={ValidationSchema}
            onSubmit={(values, { setSubmitting }) => {
              callBack(values)
                .then((value) => {
                  history.push("/support/success")
                })
                .catch((err) => {
                  setSubmitting(false);
                  updateError(err);
                });
            }}
          >
            {({ isSubmitting, handleSubmit }) => (
              <Form className="form">
                <div className="form_row">
                  <div className="field">
                    <label htmlFor="message" className="required">Bericht</label>
                    <Field as="textarea" name="message" />
                    <ErrorMessage className="error-message" name="message" component="div" />
                  </div>
                </div>                
                {!isSubmitting ? (
                  <div className="buttons">
                    <Button onClick={()=>{handleSubmit()}} label="Verstuur" disabled={isSubmitting} />
                  </div>
                ) : (
                  <Loader />
                )}
              </Form>
            )}
          </Formik>
        </FormWrapper>
  );
};
